/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem, BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

import Home           from "@material-ui/icons/Home";
import ShoppingCart   from "@material-ui/icons/ShoppingCart";
import ListAlt        from "@material-ui/icons/ListAlt";
import AccountCircle  from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles(styles);

export default function Footer(props){

  var value = 7;

  var myToken = localStorage.getItem(global.chaveLocalLogin);

  const classes = useStyles();
  const { whiteFont, history, rotaAtual, footerExtra, qtdeTiposProds } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });

  function renderFooterExtra(footerExtra) {
    if (footerExtra){
      return (
        <div style={{backgroundColor: '#fff', height: '56px', width: '100%', maxWidth: '720px', margin: 'auto'}}>
          {footerExtra}
        </div>
      );
    }    
  }

  return (
    <div className={classes.root, classes.stickToBottom}>
      { renderFooterExtra(footerExtra)}
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          switch (newValue) {
            case 0:
              history.push("/")
              break;
            case 1:
              history.push("/carrinho-compra")
              break;
            case 2:
              history.push("/pedido-lista")
              break;
            case 3:
              history.push("/login-page")
              break;
          }
        }}
        showLabels
      >
        <BottomNavigationAction className={( (rotaAtual.pathname == "/")               || (rotaAtual.pathname.includes('selecionaprod')))   ?  classes.iconeFooterSelecionado : classes.iconeFooter} label="Produtos"                       icon={<Icon className={"fa fa-store"} style={{fontSize: '1.3em', width: 'auto', height: '24px'}}/>} />
        <BottomNavigationAction className={( (rotaAtual.pathname == "carrinho-compra") || (rotaAtual.pathname.includes('carrinho-compra'))) ?  classes.iconeFooterSelecionado : classes.iconeFooter} label="Carrinho"                       icon={(qtdeTiposProds > 0) ? <div> <ShoppingCart /> <div className={classes.floatText}>{qtdeTiposProds}</div></div> : <ShoppingCart />} />
        <BottomNavigationAction className={( (rotaAtual.pathname == "/pedido-lista")   || (rotaAtual.pathname.includes('pedido-')))         ?  classes.iconeFooterSelecionado : classes.iconeFooter} label="Pedidos"                        icon={(global.pedidosPendentes) ? <div> <ListAlt /> <div className={classes.floatText} style={{backgroundColor: '#ffeb3b', color: '#000', fontWeight: 'bold', fontSize: '16px'}}>!</div></div> : <ListAlt /> } />
        <BottomNavigationAction className={( (rotaAtual.pathname == "/login-page")     || (rotaAtual.pathname.includes('usuarioinfo')))     ?  classes.iconeFooterSelecionado : classes.iconeFooter} label={(myToken) ? "Conta" : "Login"}  icon={<AccountCircle />} />
      </BottomNavigation>
    </div>
  );

}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
